import request from '../utils/request';

/**
 * @description: 文件上传
 * @param {*} data 
 */
export function uploadFile(data) {
  return request({
    url: '/api/weixin',
    method: 'post',
    data,
    config: {
      header: {
        'Content-Type': 'multipart/form-data',
      }
    }
  })
}

/**
 * @description: 身份证上传
 * @param {*} data 
 */
export function uploadFileCard(data) {
  return request({
    url: '/api/aliOssContent/uploadCard',
    method: 'post',
    data,
    config: {
      header: {
        'Content-Type': 'multipart/form-data',
      }
    }
  })
}

/**
 * @description: 识别身份证
 * @param {*} data 
 */
export function getIdCard(data) {
  return request({
    url: '/api/tailgCarRegion/cardRegion',
    method: 'get',
    params: data,
  })
}

/**
 * @description: 获取验证码
 * @param {*} data 
 */
export function getCode(data) {
  return request({
    url: `/api/weixin/getMessageCode?carOwnerId=${data.carOwnerId}&phone=${data.phone}`,
    method: 'post'
  })
}

/**
 * @description: 上传车主信息
 * @param {*} data 
 */
export function submitCarOwnerInfo(data) {
  return request({
    url: '/api/weixin/submitCarOwnerInfo',
    method: 'post',
    data
  })
}